<ngx-ui-loader [attr.data-testid]="'global-loader'" />
<hotkeys-cheatsheet [title]="'PHX Hotkeys'" />
<app-shortcut-context-menu-host />
<!-- <div ngxUiLoaderBlurred> -->
<!-- <ng-container *ngIf="isAutorized() | async; else notAuthorized">
    <app-side-nav-toolbar title="{{appInfo.title}}">
        <router-outlet></router-outlet>
    </app-side-nav-toolbar>
</ng-container>
<ng-template #notAuthorized>
    <app-single-card>
        <router-outlet></router-outlet>
    </app-single-card>
</ng-template> -->
<router-outlet />

<app-overlay-host />
<!-- </div> -->
<p-toast [autoZIndex]="false" styleClass="phx-toast-above-modals" (onClose)="onToastClose($event)">
    <ng-template pTemplate="headless" let-message let-closeFn="closeFn">
        <div class="p-toast-message-content" [class]="message?.contentStyleClass" [attr.data-testid]="'toast-message'">
            <span class="p-toast-message-icon" [attr.aria-hidden]="true">
                @switch (message?.severity) {
                    @case ('success') {
                        <i class="fas fa-check-circle"></i>
                    }
                    @case ('info') {
                        <i class="fas fa-info-circle"></i>
                    }
                    @case ('error') {
                        <i class="fas fa-times-circle"></i>
                    }
                    @case ('warn') {
                        <i class="fas fa-exclamation-triangle"></i>
                    }
                    @default {
                        <i class="fas fa-info-circle"></i>
                    }
                }
            </span>
            <div class="p-toast-message-text">
                <div class="p-toast-summary" [attr.data-testid]="message?.data?.dataTestIds?.summaryDataTestId || 'toast-summary'">{{ message?.summary }}</div>
                <div class="p-toast-detail" [attr.data-testid]="message?.data?.dataTestIds?.detailDataTestId || 'toast-detail'">{{ message?.detail }}</div>
            </div>
            <!-- @if (message?.closable !== false) { -->
                <div>
                    <button
                        type="button"
                        class="p-toast-close-button"
                        [attr.data-testid]="message?.data?.dataTestIds?.closeButtonDataTestId || 'toast-close-button'"
                        (click)="closeFn($event)"
                        (keydown.enter)="closeFn($event)"
                        [attr.aria-label]="'Close'"
                    >
                        <i class="p-toast-close-icon fas fa-times" [attr.aria-hidden]="true"></i>
                    </button>
                </div>
            <!-- } -->
        </div>
    </ng-template>
</p-toast>

<!-- just needs to in HTML -->
<app-config-widget/>
